export const CANCEL_TOPIC_CREATION_MODAL_I18N_PREFIX = "features.topics.components.cancel_topic_creation_modal";

export const CANCEL_TOPIC_CREATION_MODAL_I18N_KEYS = {
  modal_title:                       "modal_title",
  paragraph_1:                       "paragraph_1",
  paragraph_2:                       "paragraph_2",
  cancel_topic_creation_button_text: "cancel_topic_creation_button_text",
  back_button_text:                  "back_button_text"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/CancelTopicCreationModali18nConstants.js